import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import Treeselect from '@riophae/vue-treeselect';
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker'
import CONSTANT from './../../../../shared/constants/constant';
import CreateTripManagement from './../../TripManagement/CreateTripManagement';
import VueElementLoading from 'vue-element-loading';
import createmarketvehiclerequest from './../createmarketvehiclerequest';
import Util from './../../../../shared/util/util';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import XLSX from 'xlsx';
import { time } from 'highcharts';
import utility from './../../../../utility/services/utility.service';
const moment = require('moment');

export default {
	name: 'MarketVehicleRequestList',
	components: {
		Validator,
		Multiselect,
		Treeselect,
		TripServices,
		VueElementLoading,
		DatePicker,
		createmarketvehiclerequest,
		Pagination,
		Loader,
		CustomExpandableTable,
		CreateTripManagement
	},
	data: function () {
		return {
			isLoading: false,
			AWB: "",
			tableArr: [],
			branchName: null,
			branchNameList: [],
			AssignedList: [],
			AssignedSR: null,
			companyName: null,
			shortcuts: false,
			daterange: "",
			Statuslist: [
				{ id: '0', label: 'Pending' },
				{ id: '2', label: 'Rejected' },
				{ id: '1', label: 'Approved' },
			],
			status: null,
			daaata: '',
			tableColumn: ['Req. ID', 'Facility Name', 'Vehicle Type', 'Vehicle Cost', 'Estimated Trip Load(KG)', 'Vehicle Number', 'Created Date', 'Created By','Request Reason','Rejection Reason','status', 'View Images', 'Action',],
			innerTableColumn: [],
			tableItems: [],
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			total: 0,
			offset: 0,
			requestedcreateddate: "",
			createdby: null,
			Createdbylist: [],
			pageLimit: CONSTANT.PER_PAGE_DATA,
			showCreateRequestedMarketvehicle: false,
			showCreateMarketVehicleRequest: false,
			defaultHubID: "",
			requestedcreationdaterange: "",
			approvalrejectdaterange: "",
			Createdbylist: [],
			createdby: null,
			selectedVehiclereqObj: [],
			cancelrequest: false,
			requestid: '',
			viewrequest: false,

			branchNameList: [],
			AdhocVehicleList: [],
			AdhocVehicleType: '',
			AvailaibleCapacity: 0,
			AdhocVehicleName: '',
			AdhocVehicleCapacity: 0,
			reasonadhocvehicle: null,
			RouteNamelist: [],
			routename: null,
			estimatedvehicleload: null,
			reasonadhocvehicleList: [
				{ id: "0", label: "Excess Pickup" },
				{ id: "1", label: "Excess Delivery" },
				{ id: "2", label: "Appointment Delivery" },
				{ id: "3", label: "ODA" },
				{ id: "4", label: "Other" },
			],
			vehiclecost: null,
			adhocvehiclenumber: null,
			reasonremarks: false,
			vehicleNoErr: "",
			updateflag: false,
			vehicleRequestData: '',
			VehicleType: '',
			poaImages: false,
			isImageLoading: false,
			caption: "POA Image",
			poaimagearray: [],
			image: "",
			uploadimage:"",
			uploadimageCaption:"POA Image",
			rejectrequestreasonlist: [
				{ id: '0', label: 'High Cost' },
				{ id: '1', label: 'Low Capacity' },
				{ id: '2', label: 'Other' },
			],
			rejectRequest: false,
			rejectrequestreason: null,
			ViewAdhocVehicleType: '',
			ViewAdhocVehicleName: '',
			ViewAdhocVehicleCapacity: 0,
			showCreateTrip: false,
			tripStatus: null,
			TripType: '',
			rejectreasonremarks: false,
			rejectOtherReasonRemarks: null,
			approvalstatus: null,
			uploadedproof: false,
			showpoa:false,
			rowid:null,
			fieldImg: "",
			fieldcaption:"POA Image",
			poaimgArr:[],
			enableApproveRejectbtn:false,
			lastLevelFlag:false,
			approvalid:'',
			approvallevel:'',
			approvalrequestid:'',
			MyApproval:false,
			approverUserData:[],
			CancelbranchName:'',
			requestbranchName:'',
			title:'',
			previousvehiclecost:'',
			previousvehciletype: '',
			previousvehicleload:'',
			approvedchanges: '',
			editRequestDetails:false,
			disabledAfter: new Date(),
			VisbilityChanges:false,
			approveruserlength:0
		}
	},

	computed: {

	},
	async mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.localuserid = userdetail.userid;
		this.userdetail = userdetail
		this.defaultHubID = userdetail.hubID[0];
		this.tripStatus = 'created',
		this.userName = userdetail.email;
		this.userInfo = userdetail.username
		this.userRoleFlag = userdetail.rolename[0] == "Admin" || userdetail.rolename[0] == "Operations Manager" || userdetail.rolename[0] == "Cargo Controlling Tower" ? 1 : 2;
		this.getRequestedMarketVehicleList();
		Promise.all([this.getVehicleModel(), this.getHubAccessList()])
	},
	methods: {
		isNumber: function (evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				charCode > 31 &&
				(charCode < 48 || charCode > 57) &&
				charCode !== 46
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		showcreatetrip() {
			//this.parentData = {
			//  actionType: 'created'
			//}
			this.showCreateMarketVehicleRequest = true
			this.TripType = 'created'

		},
		CreateMarketVehicleRequest() {
			this.selectedVehiclereqObj = []
			this.showCreateMarketVehicleRequest = true;
			this.TripType = 'marketVehicle'
		},
		async getHubAccessList() {
			try {
				let InputPayload = {
					userid: this.localuserid
				}
				this.isLoading = true;
				let response = await TripServices.getHubAccessList(InputPayload)
				this.isLoading = false;
				let list = response.data.data.hubaccess
				list.forEach(el => {
					this.branchNameList.push({
						'id': el.HubID,
						'label': el.HubName
					})
				})
			} catch (err) {
				this.isLoading = false;
			}
		},
		async getVehicleModel() {
			try {
				this.isLoading = true;
				let result = await TripServices.getVehicleType();
				let vehicletype = result.data.data;
				for (var i = 0; i < vehicletype.length; i++) {
					if(vehicletype[i].Capacity){
						this.AdhocVehicleList.push({
							id: vehicletype[i].VehicleId,
							label: `${vehicletype[i].VehicleName} (${vehicletype[i].Capacity})`,
							capacity: vehicletype[i].Capacity,
							vehiclename: vehicletype[i].VehicleName,
						});
					}
				}
				this.isLoading = false;
			} catch (err) {
				console.log(err);
			}
		},
		selectedViewVehicleType(vehicletype) {
			vehicletype.VehicleCapacity = vehicletype.capacity.toFixed(2)
		},
		async getRouteListing() {
			try {
				this.isLoading = true;
				this.RouteNamelist = [];
				let InputPayload = {
					HubId: [this.defaultHubID],
				};
				let result = await TripServices.getRouteList(InputPayload);
				if (result.data.code == 200) {
					let RouteList = result.data.data;
					for (var i = 0; i < RouteList.length; i++) {
						this.RouteNamelist.push({
							id: RouteList[i].id,
							label: RouteList[i].routename,
							$isDisabled: RouteList[i].disable,
						});
					}
				} else {
					this.$alert(result.data.message, "", "error");
				}
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		selectRejectReason(event) {
			this.rejectreasonremarks = false;
			if (event.label.toLowerCase() == "other") {
				this.rejectreasonremarks = true;
			}else{
				this.rejectOtherReasonRemarks = null
			}
		},
		callParent() {
			this.showCreateMarketVehicleRequest = false;
			this.selectedVehiclereqObj = null;
			//this.currentPage = this.page;
			this.offset = 0;
			this.getRequestedMarketVehicleList();
		},
		resetFilter() {
			this.branchName = null
			this.approvalrejectdaterange = "",
			this.requestedcreationdaterange = ""
			this.status = null
			this.MyApproval=0;
			this.onPageChange(1)
		},
		async getRequestedMarketVehicleList() {
			this.isLoading = true
			this.vehicleRequestData = ''
			try {
				let inputPayload = {
					"offset": this.offset,
					"limit": this.pageLimit
				}
				let hubid=[];
				if (this.branchName) {
					this.branchName.forEach((item)=>{
						hubid.push(item.id)
					})
					inputPayload.hubid = hubid;
				} else if(this.MyApproval==1){
					inputPayload.username = this.userInfo
				}
				else if (this.userRoleFlag == 2) {
					inputPayload.hubid = [this.defaultHubID]
				}

				if (this.status) {
					inputPayload.status = this.status
				}
				if (this.approvalrejectdaterange[0]) {
					inputPayload.approvalrejectdaterange = this.approvalrejectdaterange;
				} else {
					this.approvalrejectdaterange = []
				}
				if (this.requestedcreationdaterange[0]) {
					inputPayload.requestedcreationdaterange = this.requestedcreationdaterange;
				} else {
					this.requestedcreationdaterange = []
				}
				let result = await TripServices.getRequestedMarketVehicle(inputPayload);
				this.isLoading = false;
				if (result.data.code == 200) {
					this.vehicleRequestData = result.data.data.rows
					this.totalCount = result.data.data.count;
					this.tableArr = result.data.data.rows;
					this.tableItems = result.data.data.rows.map((el) => {
						return {
							'id': el.id,
							'Req. ID': el.requestid,
							'Facility Name': el.hubname,
							'Vehicle Type': el.approvedwithchanges ==1 ? el.approvedvehicletype : el.requestedvehicletype,
							'Vehicle Cost': el.approvedwithchanges ==1 ? el.approvedvehiclecost : el.requestedvehiclecost,
							'Estimated Trip Load(KG)': el.approvedwithchanges ==1 ? el.approvedvehicleload : el.requestedvehicleload,
							'Vehicle Number': el.vehiclenumber,
							'View Image': el.documentimage,
							'Created Date': Util.displayDateTimeFormat( el.createddate),
							'Created By': el.createdby,
							'isMVRRejected': el.approvalstatus == 2 || el.approvalstatus == 3 ? true : false,
							'isMVRApprove': el.approvalstatus == 1 ? true : false,
							'isMVRPending': el.approvalstatus == 0 ? true : false,
							'status': el.approvalstatus == 0 ? 'Pending' : el.approvalstatus == 2 ? 'Rejected': el.approvalstatus == 3 ? 'Cancelled' : el.approvalstatus ==1 && el.approvedwithchanges ==1 ? 'Approved With Changes' : 'Approved',
							'Request Reason': el.reason =='Other' ? el.otherreason : el.reason,
							'Rejection Reason':el.rejectionreason == 'Other' ? el.otherrejectionreason : el.rejectionreason,
							'istripCreated':el.tripid ? true : false,
							'isApprovedwithChanges':el.approvedwithchanges ==1 ? true :false
						}
					})
				} else {
					this.tableItems = [];
					this.$alertify.error("No Request found","","error");
				}
				if (this.totalCount < this.pageLimit) {
					this.totalPage = 1
				} else {
					this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async preFillVehicleData(vehicletype) {
			this.ViewAdhocVehicleType =''
			this.AdhocVehicleList.map(obj => {
				if (obj.vehiclename == vehicletype.trim()) {
					this.ViewAdhocVehicleType = {
						id: obj.id,
						label: obj.vehiclename.trim(),
						VehicleCapacity: obj.capacity.toFixed(2),
						vehiclename:obj.vehiclename
					}
				}
			})
		},
		async getCustomTableEvent(id) {
			this.isLoading = true;
			this.poaimagearray =[]
			if (id.actionType == "close") {
				let selectedVehicleObj = this.tableArr.filter(function (Items) {
					return Items.id == id.id;
				});
				this.selectedVehiclereqObj = selectedVehicleObj[0];
				this.selectedVehiclereqObj.action = 'close'
				this.approvalrequestid = this.selectedVehiclereqObj.id
				this.cancelrequest = true
				this.updateflag = true
				this.requestid = this.selectedVehiclereqObj.requestid;
				this.rowid = this.selectedVehiclereqObj.id
				this.CancelbranchName = this.selectedVehiclereqObj.hubname
				this.AdhocVehicleType = this.selectedVehiclereqObj.approvedvehicletype ? this.selectedVehiclereqObj.approvedvehicletype :this.selectedVehiclereqObj.requestedvehicletype
				this.estimatedvehicleload = this.selectedVehiclereqObj.approvedvehicleload ? this.selectedVehiclereqObj.approvedvehicleload :this.selectedVehiclereqObj.requestedvehicleload
				this.reasonadhocvehicle = this.selectedVehiclereqObj.reason
				this.addOtherReasonRemarks = this.selectedVehiclereqObj.otherreason
				this.vehiclecost = this.selectedVehiclereqObj.approvedvehiclecost ? this.selectedVehiclereqObj.approvedvehiclecost : this.selectedVehiclereqObj.requestedvehiclecost
				this.routename = this.selectedVehiclereqObj.routename
				this.adhocvehiclenumber = this.selectedVehiclereqObj.vehiclenumber
				this.isLoading = false;
			}
			if (id.actionType == "view") {
				let selectedVehicleObj = this.tableArr.filter(function (Items) {
					return Items.id == id.id;
				});
				this.selectedVehiclereqObj = selectedVehicleObj[0];
				let inputPayload ={
					'id':this.selectedVehiclereqObj.id,
					'hubid': this.selectedVehiclereqObj.hubid
				}
				this.selectedVehiclereqObj.action = 'view'
				this.viewrequest = true
				this.updateflag = true
				let vehicletype = this.selectedVehiclereqObj.approvedwithchanges ? this.selectedVehiclereqObj.approvedvehicletype : this.selectedVehiclereqObj.requestedvehicletype
				this.requestid = this.selectedVehiclereqObj.requestid;
				this.requestbranchName = this.selectedVehiclereqObj.hubname
				this.approvalstatus = this.selectedVehiclereqObj.approvalstatus
				this.rowid = this.selectedVehiclereqObj.id
				await this.preFillVehicleData(vehicletype)
				this.estimatedvehicleload = this.selectedVehiclereqObj.approvedvehicleload ? this.selectedVehiclereqObj.approvedvehicleload :this.selectedVehiclereqObj.requestedvehicleload
				this.reasonadhocvehicle = this.selectedVehiclereqObj.reason
				this.addOtherReasonRemarks = this.selectedVehiclereqObj.otherreason
				this.vehiclecost = this.selectedVehiclereqObj.approvedvehiclecost ? this.selectedVehiclereqObj.approvedvehiclecost :this.selectedVehiclereqObj.requestedvehiclecost
				this.routename = this.selectedVehiclereqObj.routename
				this.adhocvehiclenumber = this.selectedVehiclereqObj.vehiclenumber
				this.approvalrequestid = this.selectedVehiclereqObj.id
				this.previousvehiclecost = this.selectedVehiclereqObj.approvedvehiclecost ? this.selectedVehiclereqObj.approvedvehiclecost :this.selectedVehiclereqObj.requestedvehiclecost
				this.previousvehciletype = this.selectedVehiclereqObj.approvedvehicletype ? this.selectedVehiclereqObj.approvedvehicletype : this.selectedVehiclereqObj.requestedvehicletype
				this.previousvehicleload = this.selectedVehiclereqObj.approvedvehicleload ? this.selectedVehiclereqObj.approvedvehicleload :this.selectedVehiclereqObj.requestedvehicleload
				let approverDetails = await TripServices.getApprovallevelDetails(inputPayload);
				let approvalObj = approverDetails.data.data
				this.approveruserlength = Object.keys(approvalObj).length;
				let userName = this.userName
				this.approverUserData=[]
				for(let key in approvalObj){
					let data  = approvalObj[key].approver
					let status = approvalObj[key].approvalstatus
					let newObj={}
					let userName =[]
					newObj.approvalstatus = status == 0 ? 'Pending' : status==1 ? 'Approved': status==3 ? 'Cancelled' :'Rejected'
					newObj.createdby = approvalObj[key].createdby
					newObj.approvedby = approvalObj[key].approvedby
					newObj.rejectedby = approvalObj[key].rejectedby
					for(let j=0;j<data.length;j++){
						if(this.userInfo == data[j].userName){
							this.editRequestDetails = true;
						}
						userName.push(data[j].userName);
					}
					newObj.userId = userName.join(', ');
					this.approverUserData.push(newObj);
				}
				let i = 0;
				for (let key in approvalObj) {
					let data = approvalObj[key].approver;
					let status = approvalObj[key].approvalstatus;
					let requestCreatedBy = approvalObj[key].createdby;
					// Check if the creator is trying to approve their own request
					if (!status) {
						if (data.some(obj => Object.values(obj).includes(requestCreatedBy)) && this.userName == requestCreatedBy) {
							this.isLoading = false
							this.$alertify.error("Creator can't approve/reject the request.");
							return false; // Exit early if creator tries to approve
						}
						let isValuePresent = data.some(obj => Object.values(obj).includes(userName));
						this.approvalid = approvalObj[key].id;
						this.approvallevel = i + 1;
				
						if (isValuePresent) {
							this.enableApproveRejectbtn = true;
							if (Object.keys(approvalObj).length === this.approvallevel) {
								this.lastLevelFlag = true;
							}
							break; // Exit loop if condition is met
						}
					}
					i++;
				}
				this.isLoading = false;
			}
			if (id.actionType == "viewimage") {
				this.poaimagearray = [];
				let Id = id.id
				let input = {
					"id": Id
				};
				let resultImage = await TripServices.GetApprovalImages(input);
				if (resultImage.data.code == 200) {
					if (resultImage.data.data && resultImage.data.data.documentimage != null) {
						this.poaImages = true;
							let inputPayload = {
								filepath : resultImage.data.data.documentimage[0]
							  }
							let presignUrlData = await TripServices.generatePresignUrl(inputPayload)
							if (presignUrlData && presignUrlData.data.code == 200) {
								this.image = presignUrlData.data.data
								this.poaimagearray.push(presignUrlData.data.data);
							}
					} else {
						this.poaImages = false
						this.$alertify.error("No Data Found")
						this.poaimagearray = [];
					}
				} else {
					this.poaImages = false
					this.$alertify.error(resultImage.data.message)
					this.poaimagearray = [];
				}
				this.isLoading = false;
			}
			if (id.actionType == "approve") {
				let selectedVehicleObj = this.tableArr.filter(function (Items) {
					return Items.id == id.id;
				});
				this.selectedVehiclereqObj = selectedVehicleObj[0];
				this.selectedVehiclereqObj.marketvehiclereqflag = 'true'
				this.selectedVehiclereqObj.VehicleType = 'market'
				this.selectedVehiclereqObj.wheeler = '4'
				this.VisbilityChanges = true;
					
			}
			this.isLoading = false;
		},
		searchRequest() {
			this.currentPage = 1;
			this.offset = 0;
			this.getRequestedMarketVehicleList();
		},

		onPageChange(page) {
			this.currentPage = page;
			this.offset = (page - 1) * this.pageLimit
			this.getRequestedMarketVehicleList();
		},
		closeViewrequest() {
			this.rejectRequest = false;
			this.viewrequest = false;
			this.updateflag = false;
			this.uploadedproof = false
			this.rejectrequestreason = ""
			this.enableApproveRejectbtn = false
			this.lastLevelFlag = false;
			this.approvallevel = ''
			this.previousvehiclecost = ''
			this.previousvehciletype = ''
			this.previousvehicleload = ''
		},
		closeCancelrequest() {
			this.showpoa = false
			this.cancelrequest = false;
		},
		async viewSelectedImage(event,image) {
			this.poaimagearray = [];			
				let input = {
					"id": event
				};
				this.isLoading = true
				let resultImage = await TripServices.GetApprovalImages(input);
				this.isLoading = false;
				if (resultImage.data.code == 200) {
					if (resultImage.data.data) {
						if(resultImage.data.data.documentimage != null && image == 'document'){
							let inputPayload = {
								filepath : resultImage.data.data.documentimage[0]
							}
							let presignUrlData = await TripServices.generatePresignUrl(inputPayload)
							if (presignUrlData && presignUrlData.data.code == 200) {
								this.openImage2(presignUrlData.data.data);
							}
						}else if(resultImage.data.data.pancardimage!= null && image == 'pancard'){
							let inputPayload = {
								filepath : resultImage.data.data.pancardimage[0]
							}
							let presignUrlData = await TripServices.generatePresignUrl(inputPayload)
							if (presignUrlData && presignUrlData.data.code == 200) {
								this.openImage2(presignUrlData.data.data);
							}
						}else {
							this.$alertify.error("No Data Found")
						}
					} else {
				        this.$alertify.error("No Data Found")
						this.poaimagearray = [];
					}
				} else {
				    this.$alertify.error(resultImage.data.message)
					this.poaimagearray = [];
				}
				this.isLoading = false;
		},
		async ApprovalRequest(event) {
			try {
				let inputPayload = {
					requestid: this.requestid
				}
				this.approvedchanges = 0 
				if (this.ViewAdhocVehicleType == "") {
					this.$alert("Please select vehicle type", "", "error");
					return false;
				}
				if (this.estimatedvehicleload == "") {
					this.$alert("Please Enter the Estimated Vehicle Load", "", "error");
					return false;
				}
				if (this.vehiclecost == "") {
					this.$alert("Please enter the vehicle cost", "", "error");
					return false;
				}
				if(parseInt(this.previousvehiclecost) !== parseInt(this.vehiclecost) || this.previousvehciletype !==this.ViewAdhocVehicleType.vehiclename || parseInt(this.previousvehicleload) !==  parseInt(this.estimatedvehicleload)){
					this.approvedchanges = 1
				}
				if( parseInt(this.vehiclecost) > parseInt(this.previousvehiclecost) && this.approveruserlength!=this.approvallevel){
					this.lastLevelFlag = false;
				}
				inputPayload.approvedvehicletype = this.ViewAdhocVehicleType.vehiclename
				inputPayload.approvedvehiclecost = parseInt(this.vehiclecost)
				inputPayload.approvedvehicleload = parseInt(this.estimatedvehicleload)
				inputPayload.lastmodifiedby = this.userName
				inputPayload.approvalid = this.approvalid
				inputPayload.approvalflag = this.lastLevelFlag,
				inputPayload.approvalrequestid = this.approvalrequestid,
				inputPayload.approvedwithchanges = this.approvedchanges;
 				inputPayload.actiontype = 'approved'
				inputPayload.vehiclecapacity = this.ViewAdhocVehicleType.VehicleCapacity
				this.isLoading = true;
				let result = await TripServices.approveRejectRequest(inputPayload)
				this.isLoading = false;
				if (result.data.code == 200) {
					this.$alert(` Request ID ${this.requestid}. has beeen approved!!`, "", "success");
					this.closeViewrequest();
					this.getRequestedMarketVehicleList();
				} else {
					document.activeElement.blur();
					this.$alert(result.data.message, "", "error");
				}
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error(error);
			}
		},
		async submitRejectRequestReason() {
			try {
				let inputPayload = {
					requestid: this.requestid
				}
				if (!this.rejectrequestreason) {
					this.$alertify.error("Please select reason of rejection");
					return false;
				} else if (this.rejectrequestreason.label.toLowerCase() == 'other') {
					if (!this.rejectOtherReasonRemarks) {
						this.$alertify.error("Please Enter the Other Rejection reasons remarks");
						return false;
					}else{
						inputPayload.rejectOtherReasonRemarks = this.rejectOtherReasonRemarks
					}
				}
				inputPayload.lastmodifiedby = this.userName
				inputPayload.rejectionreason = this.rejectrequestreason.label
				inputPayload.approvalid = this.approvalid
				inputPayload.approvalflag = this.lastLevelFlag 
				inputPayload.approvalrequestid = this.approvalrequestid
				if(this.rejectrequestreason){
					inputPayload.rejectionreason = this.rejectrequestreason.label
					if(this.rejectrequestreason.label.toLowerCase() == "other"){
						if(this.rejectOtherReasonRemarks){
							inputPayload.rejectOtherReasonRemarks = this.rejectOtherReasonRemarks
						}else{
							this.$alertify.error("Please enter the Other Rejection Remarks");
						}
					}
				}
				inputPayload.actiontype = 'rejected'
				this.isLoading = true;
				let result = await TripServices.approveRejectRequest(inputPayload)
				this.isLoading = false;
				if (result.data.code == 200) {
					this.$alert(`Request ID ${this.requestid} has been REJECTED`, "", "error");
					this.closeViewrequest();
					this.resetRejectRequestReason();
					this.getRequestedMarketVehicleList();
				} else {
					document.activeElement.blur();
					this.$alert(result.data.message, "", "error");
				}
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error(error);
				this.rejectRequest = false;
			}
		},
		async resetRejectRequestReason(event) {
			this.rejectRequest = false;
			this.rejectOtherReasonRemarks = null
			this.rejectreasonremarks = false
			this.rejectrequestreason = null
		},
		Rejectrequest(event) {
			this.rejectRequest = true;
		},
		async cancelApprovalRequest() {
			try {
				let inputPayload = {
					requestid: this.requestid
				}
				inputPayload.lastmodifiedby = this.userName
				inputPayload.approvalrequestid = this.approvalrequestid
				inputPayload.actiontype = 'cancelled'
				this.isLoading = true;
				let result = await TripServices.approveRejectRequest(inputPayload)
				this.isLoading = false;
				if (result.data.code == 200) {
					this.$alert(`Request ID ${this.requestid} has been CANCELLED`, "", "error");
					this.closeCancelrequest();
					this.getRequestedMarketVehicleList();
				} else {
					document.activeElement.blur();
					this.$alert(result.data.message, "", "error");
				}
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error(error);
			}
		},
		async openImage(image) {
			this.image = image
			this.$nextTick(() => {
				let modal = document.getElementById('myModalImg' + image);
				var img = document.getElementById('imgid' + image);
				var modalImg = document.getElementById("img" + image);
				var captionText = document.getElementById("captionImg" + this.caption);

				modal.style.display = "block";
				modalImg.src = image;
				captionText.innerHTML = this.caption;
				this.poaImages = false;
			})
		},
		closemodal(id) {
			let modal = document.getElementById(id);
			modal.style.display = "none";
			this.poaImages = true;
		},
		closemodal2(id) {
			let modal = document.getElementById(id);
			modal.style.display = "none";
		},
		closePoaImages() {
			this.poaimagearray = []
			this.showpoa = false
			this.uploadedproof = false
			this.poaImages = false
		},
		async fileview(index) {
			let inputPayload = {
				filepath : index
			  }
			let presignUrlData = await TripServices.generatePresignUrl(inputPayload)
			if (presignUrlData && presignUrlData.data.code == 200) {
				var link = document.createElement('a');
				link.href =presignUrlData.data.data
				link.setAttribute('download', '');
				link.setAttribute("target", "_blank");
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				// window.open(index, '_blank');
				// link.remove();
				return true;
			  } else {
				this.$alert("Something Went Wrong", '', "Error");
			  }     
		},
		async DownloadRequestedData() {
			try {
				this.isLoading = true;
				let inputPayload = {}
				let hubid=[];
				if (this.branchName) {
					this.branchName.forEach((item)=>{
						hubid.push(item.id)
					})
					inputPayload.hubid = hubid;
				} else if(this.MyApproval==1){
					inputPayload.username = this.userInfo
				}
				else if (this.userRoleFlag == 2) {
					inputPayload.hubid = [this.defaultHubID]
				}
				if (this.status) {
					inputPayload.status = this.status
				}
				if (this.approvalrejectdaterange[0]) {
					inputPayload.approvalrejectdaterange = this.approvalrejectdaterange;
				} else {
					this.approvalrejectdaterange = []
				}
				if (this.requestedcreationdaterange[0]) {
					inputPayload.requestedcreationdaterange = this.requestedcreationdaterange;
				} else {
					this.requestedcreationdaterange = []
				}
				let result = await TripServices.getRequestedMarketVehicle(inputPayload)
				let tempdata = result.data.data.rows.map((el) => {
					return {
						'Req. ID': el.requestid,
						'Facility Name': el.hubname,
						'Requested Vehicle Type': el.requestedvehicletype,
						'Requested Vehicle Cost': el.requestedvehiclecost,
						'Requested Estimated Trip Load(KG)': el.requestedvehicleload,
						'Vehicle Number': el.vehiclenumber,
						'Approval Image': el.documentimage ? el.documentimage[0] : null,
						'Created Date': el.createddate ? moment(el.createddate).format('YYYY-MM-DD hh:mm:ss') : null,
						'Created Date': Util.displayDateTimeFormat(el.createddate),
						'Created By': el.createdby,
						'status': el.approvalstatus == 0 ? 'Pending' : el.approvalstatus == 2 ? 'Rejected': el.approvalstatus == 3 ? 'Cancelled' : el.approvalstatus ==1 && el.approvedwithchanges ==1 ? 'Approved With Changes' : 'Approved',
						'Approver/Rejector ID': el.approvalstatus == 2 || el.approvalstatus == 1 ? el.lastmodifiedby : null,
						'Approval/Rejection Date': el.approvaldatetime ? Util.displayDateTimeFormat(el.approvaldatetime) : null,
						'Approved Vehicle Type': el.approvalstatus ==1 ? el.approvedvehicletype : null,
						'Approved Vehicle Cost': el.approvalstatus ==1 ? el.approvedvehiclecost : null,
						'Approved Estimated Trip Load(KG)': el.approvalstatus ==1 ? el.approvedvehicleload : null,
						'Request Reason': el.reason,
						'Request Other Reason': el.otherreason,
						'Rejection Reason': el.rejectionreason,
						'Rejected Other Reason': el.otherrejectionreason,
					}
				})
				let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
				const data = XLSX.utils.json_to_sheet(tempdata);
				const wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, data, 'data')
				XLSX.writeFile(wb, dt + '_marketVehicleRequestData.xlsx');
				this.isLoading = false;
			} catch (err) {
				console.log(err);
				this.isLoading = false;
			}
		},
		  openImage2(image) {
			this.uploadimage = image
			  this.$nextTick(() => {
				let modal = document.getElementById('myuploadModalImg' + image);
				var img = document.getElementById('imguploadid' + image);
				var modalImg = document.getElementById("uploadimg" + image);
				var captionText = document.getElementById("captionImg" + this.uploadimageCaption);
				modal.style.display = "block";
				modalImg.src = image;
				captionText.innerHTML =  this.uploadimageCaption;

			  })
		  },
		  closeVisbilityChanges(){
			this.VisbilityChanges = false
		  },
		  createRequestedvehicleTrip(){
			    this.closeVisbilityChanges();
				if(this.selectedVehiclereqObj.hubid == this.defaultHubID){
					this.showcreatetrip('created');
				}else{
					this.$alertify.error(`Please Logged in to ${this.selectedVehiclereqObj.hubname} to create the Trip for Req. ID ${this.selectedVehiclereqObj.requestid}`)
				}
		  },
	}
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/marketvehicleflm/marketvehiclelist/marketvehiclelist.component.js